/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactListResponsePaging } from '../../models/contact-list-response-paging';

export interface GetContacts$Params {
  page: number;
  pageSize: number;
  orderBy?: string;
  filter?: string;
}

export function getContacts(http: HttpClient, rootUrl: string, params: GetContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactListResponsePaging>> {
  const rb = new RequestBuilder(rootUrl, getContacts.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('filter', params.filter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContactListResponsePaging>;
    })
  );
}

getContacts.PATH = '/contacts';
